import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { authorsInfo } from '../../../../content/assets/authors/authors-info';
import { Author, AuthorContent } from '../../../types/author';

export const isAuthorActive = (author: string) => authorsInfo[author]?.active ?? false;

export const authorLink = (author: string) => `/authors/${author!.replace(/_/g, '-')}`;

export const authorName = (author: string) => author.split('_').join(' ');

const useAuthorImage: (author: string) => IGatsbyImageData = (author: string) => {
  const data = useStaticQuery<Queries.AuthorsPictureQuery>(graphql`
    query AuthorsPicture {
      allFile(filter: { relativeDirectory: { eq: "authors" }, extension: { regex: "/(jpg)|(jpeg)|(png)/" } }) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
            name
          }
        }
      }
    }
  `);

  return data.allFile!.edges!.find(({ node }) => node!.name === author)!.node!.childImageSharp!.gatsbyImageData!;
};

export const useAuthor = (author: string): Author => {
  const authorImage = useAuthorImage(author);
  const authorInfo = authorsInfo[author];

  return {
    authorName: authorName(author),
    authorImage,
    authorLink: authorLink(author),
    authorBio: authorInfo.bio,
    authorRole: authorInfo.role,
    active: authorInfo.active,
  };
};

export const useShouldShowAuthorsInfo = (authors: ReadonlyArray<string>) =>
  authors.map((author) => authorsInfo[author]).filter((authorInfo: AuthorContent) => authorInfo.active).length > 0;
